import { Select } from "./select.element.js";

export default Select;

Select.define('wje-select', Select);
